import { deviceMap } from "../../define/define_list";
import { deviceManager } from "../../device/device_manager";
import { DpiAction, type PostSetDpiData } from "../../driver/data_type/response";
import { dataProfileManage } from "../../snapshot/profile";

export const handleSetDPI = async (data: PostSetDpiData) => {
    const config = dataProfileManage().dataProfile
    config.Mouse.Rate = data.Rate;

    const dpiLen = deviceMap[deviceManager.deviceID].support.Limit.DpiLen
    if(config.Mouse.DpiList.length > dpiLen){
        throw new Error("DpiList length is too long");
    }

    if(data.DpiIndex < 0 || data.DpiIndex > dpiLen-1){
        throw new Error("DpiIndex is out of range");
    }


    if(data.Action == DpiAction.Add){
        config.Mouse.DpiList.push(data.DpiData.Dpi)
        config.Mouse.DpiColors.push(data.DpiData.Color)
    } else if(data.Action == DpiAction.Mod){
        config.Mouse.DpiList[data.DpiIndex] = data.DpiData.Dpi
        config.Mouse.DpiColors[data.DpiIndex] = data.DpiData.Color
    } else if(data.Action == DpiAction.Del){
        if(config.Mouse.DpiIndex > data.DpiIndex){
            config.Mouse.DpiIndex = config.Mouse.DpiIndex - 1
        }
        config.Mouse.DpiList.splice(data.DpiIndex, 1)
        config.Mouse.DpiColors.splice(data.DpiIndex, 1) 
    }

    dataProfileManage().save()
    await deviceManager.deviceDriver.syncConfig()
    return config.Mouse
}
